module.exports = __webpack_public_path__ + "img/footer-map.5673fd14.png";